/* =============================================
   SENCHADO HEADER — interactions
   - Smart Sticky (scroll down hides nav, scroll up shows)
   - Mega menu (hover on PC, click on mobile)
   - Drawer (mobile hamburger)
   ============================================= */

(function () {
  'use strict';

  const SELECTORS = {
    header: '.senchado-header',
    nav: '.senchado-header__nav',
    navItems: '.senchado-nav-item',
    navItemsWithMega: '.senchado-nav-item[data-mega]',
    megaBackdrop: '.senchado-mega-backdrop',
    hamburger: '.senchado-header__hamburger',
    drawer: '.senchado-drawer',
    drawerBackdrop: '.senchado-drawer-backdrop',
    drawerItemToggle: '.senchado-drawer__link--toggle',
    megaClose: '.senchado-mega__close-bar',
  };

  function init() {
    const header = document.querySelector(SELECTORS.header);
    const nav = document.querySelector(SELECTORS.nav);
    if (!header || !nav) return;

    const megaBackdrop = document.querySelector(SELECTORS.megaBackdrop);
    const drawer = document.querySelector(SELECTORS.drawer);
    const drawerBackdrop = document.querySelector(SELECTORS.drawerBackdrop);
    const hamburger = document.querySelector(SELECTORS.hamburger);

    // ---------- Mega menu ----------
    // SP 背景スクロールロック（2026-07 オーナー実機報告のUXバグ対策・第1防御）:
    // SPでパネルが1画面に収まると内部スクロール余地がなく、スワイプが背後の
    // ページ本体へチェーン → Smart Sticky の onScroll が closeAllMega を誤発火して
    // メガが閉じる。openMega(SP時)で body を position:fixed 方式でロックし遮断する。
    // 状態はクラス(senchado-mega-scroll-lock)と style.top のDOMのみに持つ
    // （closure変数に持たない）ため、theme editor の section:load 再init後も
    // 対称に解除でき、ロック/解除がリークなく必ず対になる。
    function lockBodyScroll() {
      if (document.body.classList.contains('senchado-mega-scroll-lock')) return; // メガ→別メガ切替時はロック維持（scrollY を取り直さない）
      const y = window.scrollY;
      document.body.classList.add('senchado-mega-scroll-lock');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + y + 'px';
      document.body.style.width = '100%';
    }

    function unlockBodyScroll() {
      if (!document.body.classList.contains('senchado-mega-scroll-lock')) return; // PC等・未ロック時は何もしない
      const y = Math.abs(parseInt(document.body.style.top, 10)) || 0;
      document.body.classList.remove('senchado-mega-scroll-lock');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, y); // ロック時に0へ飛んだ文書スクロールを元位置へ復元
    }

    function closeAllMega() {
      document.querySelectorAll(SELECTORS.navItems).forEach((n) => n.classList.remove('is-open'));
      header.classList.remove('has-mega-open');
      if (megaBackdrop) megaBackdrop.classList.remove('is-visible');
      // 解除はここに一元化（ESC/backdrop/closeBar/リンク再タップ/resize/scroll すべて経由）
      unlockBodyScroll();
    }

    function openMega(item) {
      document.querySelectorAll(SELECTORS.navItems).forEach((n) => n.classList.remove('is-open'));
      item.classList.add('is-open');
      header.classList.add('has-mega-open');
      if (megaBackdrop) megaBackdrop.classList.add('is-visible');
      // PC(hover)はロック不要・従来挙動不変。SPのみ背景スクロールを遮断
      if (!isDesktopHover()) lockBodyScroll();
    }

    function isDesktopHover() {
      return window.matchMedia('(hover: hover)').matches && window.innerWidth >= 768;
    }

    document.querySelectorAll(SELECTORS.navItemsWithMega).forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (isDesktopHover()) openMega(item);
      });
      item.addEventListener('mouseleave', () => {
        if (isDesktopHover()) {
          // 即時close（谷本さん指示 2026-06-01: ラグでスクロール待ちが発生するため遅延撤去）。
          if (!document.querySelector('.senchado-nav-item:hover')) closeAllMega();
        }
      });

      const link = item.querySelector('.senchado-nav-item__link');
      if (link) {
        link.addEventListener('click', (e) => {
          // On mobile or PC narrow, toggle. On wide PC with hover, still navigate.
          if (isDesktopHover()) return;
          e.preventDefault();
          if (item.classList.contains('is-open')) closeAllMega();
          else openMega(item);
        });
      }

      const closeBar = item.querySelector(SELECTORS.megaClose);
      if (closeBar) {
        closeBar.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          closeAllMega();
        });
      }
    });

    if (megaBackdrop) {
      megaBackdrop.addEventListener('click', closeAllMega);
    }

    // ---------- Drawer ----------
    function openDrawer() {
      if (!drawer) return;
      // メガとドロワーの排他化。開いているメガを先に閉じ（＝unlockBodyScroll される）、
      // その上でドロワー用に body をロックし直す。これでロックの所有者が常に1つになり、
      // 片方を閉じたときに他方のロックを誤って解除する不整合を防ぐ。
      closeAllMega();
      drawer.classList.add('is-open');
      if (drawerBackdrop) drawerBackdrop.classList.add('is-visible');
      // iOS Safari は body { overflow:hidden } では背面のタッチスクロールを止められない。
      // メガと同じ position:fixed 方式（lockBodyScroll）で背面スクロールを遮断する。
      lockBodyScroll();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (drawerBackdrop) drawerBackdrop.classList.remove('is-visible');
      unlockBodyScroll();
    }

    if (hamburger) {
      hamburger.addEventListener('click', () => {
        if (drawer && drawer.classList.contains('is-open')) closeDrawer();
        else openDrawer();
      });
    }

    if (drawerBackdrop) {
      drawerBackdrop.addEventListener('click', closeDrawer);
    }

    document.querySelectorAll(SELECTORS.drawerItemToggle).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const item = btn.closest('.senchado-drawer__item');
        if (!item) return;
        document.querySelectorAll('.senchado-drawer__item.is-open').forEach((other) => {
          if (other !== item) other.classList.remove('is-open');
        });
        item.classList.toggle('is-open');
      });
    });

    // ---------- Smart Sticky ----------
    let lastScrollY = window.scrollY;
    const onScroll = () => {
      // 第2防御(保険): SPでメガopen中はロック着脱に伴う擬似scroll(0へのジャンプ/復元)や
      // 貫通スクロールで closeAllMega・is-hidden を誤発火させない。
      // PCのスクロールで閉じる挙動・Smart Sticky 本体（メガ非表示時の is-scrolled 等）は不変
      if (!isDesktopHover() && document.querySelector('.senchado-nav-item.is-open')) return;
      const currentY = window.scrollY;
      if (currentY > 80) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');

      if (currentY > 120 && currentY > lastScrollY) {
        nav.classList.add('is-hidden');
        header.classList.add('is-nav-hidden');
        closeAllMega();
      } else {
        nav.classList.remove('is-hidden');
        header.classList.remove('is-nav-hidden');
      }
      lastScrollY = currentY;
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // ---------- ESC closes ----------
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAllMega();
        closeDrawer();
      }
    });

    // ---------- Resize: close mega on breakpoint change ----------
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(closeAllMega, 150);
    });

    // ---------- Initial scroll state ----------
    onScroll();

    // Expose for Shopify section lifecycle
    header._senchadoHeader = { closeAllMega, closeDrawer, onScroll };
  }

  // ---------- Cart count live sync ----------
  // 煎茶堂ヘッダーは Dawn の #cart-icon-bubble を使わず独自の #senchado-cart-count を持つため、
  // カート変更時の数バッジ更新が Dawn の section 再描画に乗らない。ここで明示的に同期する。
  // 追加: hero / compare-buy が dispatch する 'cart:updated'(DOM, 件数なし) → /cart.js で再取得
  // 数量変更・削除: cart.js が publish する PUB_SUB cartUpdate(cartData.item_count あり)
  function setCartCount(count) {
    if (typeof count !== 'number' || Number.isNaN(count)) return;
    const badge = document.getElementById('senchado-cart-count');
    if (badge) {
      badge.textContent = String(count);
      badge.setAttribute('data-count', String(count));
      // aria-label はバッジを内包するカートリンクにだけ付与する。
      // querySelector('.senchado-header__icon-link') はDOM先頭=検索リンクを返すため、
      // バッジから closest() でカートリンク自身を特定する（検索アイコンの誤ラベルを防ぐ）。
      const cartLink = badge.closest('.senchado-header__icon-link');
      if (cartLink) cartLink.setAttribute('aria-label', `カート (${count}点)`);
    }
  }

  function fetchCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => setCartCount(cart.item_count))
      .catch(() => {});
  }

  document.addEventListener('cart:updated', fetchCartCount);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const c = event && event.cartData ? event.cartData.item_count : undefined;
      if (typeof c === 'number') setCartCount(c);
      else fetchCartCount();
    });
  }

  // ---------- bfcache 復元ガード（scroll-lock リーク解除） ----------
  // ドロワー/SPメガを開いた状態でパネル内リンクを踏むと closeDrawer/closeAllMega を経ずに離脱するため、
  // body は position:fixed のロック（class=senchado-mega-scroll-lock + inline style）を保持したまま
  // bfcache に格納される。iOS Safari の「戻る」は bfcache からページを復元し DOMContentLoaded も
  // shopify:section:load も発火しない → init が走らずロックが残存し、ページ最上部固着・スクロール不能に
  // なる（リロードするまで復旧しない）。pageshow(persisted) で DOM に残ったロック状態を直接解除する。
  // ロック状態のSSOTはクラス+inline style（closure変数ではない）ため、init のクロージャに依存せず
  // モジュールスコープから対称に解除できる。bfcache が効かない素の再ロード時は persisted=false で
  // 早期 return し init が新規HTMLで走るので無害＝純粋な保険（非破壊）。
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    if (document.body.classList.contains('senchado-mega-scroll-lock')) {
      const y = Math.abs(parseInt(document.body.style.top, 10)) || 0;
      document.body.classList.remove('senchado-mega-scroll-lock');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, y); // ロック時に0へ飛んだ文書スクロールを離脱前の位置へ復元
    }
    // bfcache は is-open/is-visible クラスも復元するため、開いていたドロワー/メガの表示状態もリセット
    const drawerEl = document.querySelector(SELECTORS.drawer);
    if (drawerEl) drawerEl.classList.remove('is-open');
    const drawerBackdropEl = document.querySelector(SELECTORS.drawerBackdrop);
    if (drawerBackdropEl) drawerBackdropEl.classList.remove('is-visible');
    document.querySelectorAll(SELECTORS.navItems).forEach((n) => n.classList.remove('is-open'));
    const headerEl = document.querySelector(SELECTORS.header);
    if (headerEl) headerEl.classList.remove('has-mega-open');
    const megaBackdropEl = document.querySelector(SELECTORS.megaBackdrop);
    if (megaBackdropEl) megaBackdropEl.classList.remove('is-visible');
  });

  // Shopify Theme Editor: re-init when section reloads
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector(SELECTORS.header)) init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
